import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/Home')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login')
    },
    {
      path: '/adxData',
      name: 'AdxDataReport',
      component: () => import('@/views/AdxDataReport')
    },
    {
      path: "/setting",
      name: "Setting",
      component: () => import("@/views/Setting")
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js